import { IRootState } from 'reducers';
import { AdminViewModeSettingsState } from 'reducers/admin/viewModeSettings';
import { createSelector } from 'reselect';
import { configSelector } from 'selectors/common';

import { filterVisibilitySectionsByConfig } from './utils';

export const adminViewModeSettingsSelector = createSelector(
  [(state: IRootState) => state.adminViewModeSettings, configSelector],
  (adminViewModeSettings, config) => {
    if (!config) {
      const content = adminViewModeSettings.content;
      const settingsState: AdminViewModeSettingsState = {
        ...adminViewModeSettings,
        content: content
          ? {
              ...content,
              setting: {
                visibilitySettings: [],
              },
            }
          : null,
      };

      return settingsState;
    }

    const settings = adminViewModeSettings.content?.setting.visibilitySettings;
    const filteredSettings = settings ? filterVisibilitySectionsByConfig(settings, config) : undefined;

    const filteredUserSettings: AdminViewModeSettingsState = {
      ...adminViewModeSettings,
      content: adminViewModeSettings.content
        ? {
            ...adminViewModeSettings.content,
            setting: {
              visibilitySettings: filteredSettings ?? [],
            },
          }
        : null,
    };

    return filteredUserSettings;
  },
);
